module.exports = __webpack_public_path__ + "img/_1.3344a6c9.png";